/**
 * Включаемые при сборке возможности.
 *
 * ИИ-помощник врача — панель у каждого документа (диктовка GigaAM,
 * заполнение полей, диагноз и рекомендации), раздел «ИИ-помощник» в
 * администрировании и страница /ai системного администратора — по умолчанию
 * скрыт. Включается сборкой с VITE_AI=1 (vite.config.ts); после этого
 * показывать ли его врачам, решает администратор (настройка ai_enabled).
 * Сервер (/api/ai, api/src/model) при этом не меняется: пока к помощнику не
 * обращаются, модель не обучается и ресурсов не тратит.
 */
declare const __AI__: boolean | undefined;

/** typeof — для запуска вне Vite (render-smoke через tsx), где __AI__ не подставлен. */
export const AI_ENABLED: boolean = typeof __AI__ !== "undefined" && __AI__ === true;
